// extracted by mini-css-extract-plugin
export default {"navBtn":"AziendaNavigator_navBtn__ji2ZR"};